module.exports = __webpack_public_path__ + "static/media/Ram Face 1c.30924e4a.svg";